import { inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { AbcAnalysisProductColumnsRepository } from '../repositories/abc-analysis-product-columns.repository';
import { AbcAnalysisColumn, AbcAnalysisColumnsResponse } from '../types/abc-analysis-columns-response';

@Injectable()
export class AbcAnalysisProductColumnsService extends ReadonlyRepositoryCollectionService<
  AbcAnalysisColumn,
  AbcAnalysisColumnsResponse,
  undefined
> {
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(AbcAnalysisProductColumnsRepository));
  }

  protected override getAll(
    result: AbcAnalysisColumnsResponse | null | undefined
  ): AbcAnalysisColumn[] {
    return (result?.columns ?? []).map((name) => ({ name }));
  }

  protected override getId = (item: AbcAnalysisColumn): string => item.name;
}
